function config() {
    this.timesync_host = 'https://digital-report-socket-time.mksz.hu';
    this.timesync_port = 443;
    this.socket_host = 'https://digital-report-socket.mksz.hu';
    this.socket_port = 443;
    this.socket_debug = false;

    this.loginmethod = "backoffice";

    this.sentry_dsn = false;
}

module.exports = new config();
